module.exports = __webpack_public_path__ + "media/icon/icon-location-226c8dbb.svg";